import { EEnvPlatform } from 'affiny-core/env.types';
import { IKvkType } from '../api/models/account/account.types';
import { IHydratedReflist } from '../api/repositories/reflists/reflists.types';

export enum EReflistsActionType {
  GET = 'REFLISTS_GET',
  GET_SUCCESS = 'REFLISTS_GET_SUCCESS',
}

export interface IGetReflistsAction {
  type: EReflistsActionType.GET;
}

export const getReflistsAction = (): IGetReflistsAction => ({
  type: EReflistsActionType.GET,
});

interface IReflists {
  me: IHydratedReflist;
  other: IHydratedReflist;
  platform: EEnvPlatform;
  kvk: IKvkType;
}

export interface IGetReflistsSuccessAction {
  type: EReflistsActionType.GET_SUCCESS;
  payload: IReflists;
}

export const getReflistsSuccessAction = (
  reflists: IReflists
): IGetReflistsSuccessAction => ({
  type: EReflistsActionType.GET_SUCCESS,
  payload: reflists,
});

export type IReflistsAction = IGetReflistsAction | IGetReflistsSuccessAction;
